import { memo, type FC } from "react"
import Box from "@mui/material/Box"

import { ARROW_SPLIT, MARKER_BAND_HEIGHT } from "./helpers"
import GridCell from "./GridCell"
import SpanMarkerArrow from "./SpanMarkerArrow"

interface LaneMarkerBandProps {
  visibleIndexes: number[]
  peakIndex: number | null
  currentIndex: number | null
  isSplit: boolean
  peakColor: string
  peakLabel: string
  currentLabel: string
  currentCaption: string | null
  hitWidth: number
}

const LaneMarkerBand: FC<LaneMarkerBandProps> = ({
  visibleIndexes,
  peakIndex,
  currentIndex,
  isSplit,
  peakColor,
  peakLabel,
  currentLabel,
  currentCaption,
  hitWidth,
}) => (
  <Box sx={{ display: "flex", height: MARKER_BAND_HEIGHT }}>
    {visibleIndexes.map((index) => {
      const spanIndex = index + 1
      return (
        <GridCell key={spanIndex}>
          {spanIndex === peakIndex && (
            <SpanMarkerArrow
              label={peakLabel}
              offset={isSplit ? -ARROW_SPLIT : 0}
              color={peakColor}
              hitWidth={hitWidth}
            />
          )}
          {spanIndex === currentIndex && (
            <SpanMarkerArrow
              label={currentLabel}
              caption={currentCaption}
              offset={isSplit ? ARROW_SPLIT : 0}
              color="#FFFFFF"
              hitWidth={hitWidth}
            />
          )}
        </GridCell>
      )
    })}
  </Box>
)

// Nothing here depends on hover, so memoizing skips a row of cells per lane on
// every hover step and every frame of a drag.
export default memo(LaneMarkerBand)
